module.exports = __webpack_public_path__ + "static/media/25a Closed Guard.ce4c2bac.jpg";